import React from 'react';
import {
  createStyles,
  FormControl,
  FormHelperText,
  InputLabel,
  makeStyles,
  Switch,
  SwitchProps
} from '@material-ui/core';
import {INPUT_LABEL_COLOR} from 'src/style/variable';

interface ISwitchInputField extends Omit<SwitchProps, 'error'> {
  label?: string;
  error?: Record<string, any>;
  onChange?: (e: any) => void;
}

const useStyles = makeStyles(() => {
  return createStyles({
    formControl: {
      paddingBottom: 0,
      marginBottom: 0,
      '& .MuiFormLabel-asterisk': {
        color: 'inherit'
      }
    }
  });
});

const SwitchInputField = (props: ISwitchInputField): JSX.Element => {
  const {label, error, ...rest} = props;
  const classes = useStyles();
  return (
    <FormControl
      className={classes.formControl}
      error={!!error}
      fullWidth={true}
      variant="standard"
      required={rest?.required}>
      {label && (
        <InputLabel
          style={{
            position: 'static',
            transform: 'none',
            marginBottom: '0.5rem',
            fontSize: '1.1rem',
            color: INPUT_LABEL_COLOR
          }}
          shrink>
          {label}
        </InputLabel>
      )}
      <Switch
        color="primary"
        checked={!!rest.value}
        {...rest}
        onChange={e => {
          if (rest.onChange) {
            rest.onChange(e.target.checked);
          }
        }}
      />
      {error && <FormHelperText>{error.message}</FormHelperText>}
    </FormControl>
  );
};

export default SwitchInputField;
